import styled from "styled-components";

import { SelectFilterRow } from "../../../containers/sims/styledSimPage";

export const SimsRow = styled(SelectFilterRow)`
  grid-template-columns: ${({ $isProfile }) => $isProfile && "repeat(3, 1fr)"};
  @media screen and (max-width: 1200px) {
    /* grid-template-columns: repeat(2, 360px); */
    grid-template-columns: ${({ $isProfile }) =>
      $isProfile ? "repeat(2, 1fr)" : "repeat(2, 360px)"};
  }
  @media screen and (max-width: 992px) {
    grid-template-columns: ${({ $isProfile }) => $isProfile && "1fr"};
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const FilterResultP = styled.p`
  strong {
    margin-left: 1.5rem;
    color: var(--text-color-dark);
  }
  span {
    color: var(--dark-color);
  }
`;
